import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert } from 'shared/mui/Alert/Alert';

export const CommissionsTabsTaskNotExist: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <Alert severity="info">
      {translate('app.merchantCommissions.noCommissionRecalculationTasks')}.
    </Alert>
  );
};
